import React from 'react';
import { withRouter } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import withStyles from "@material-ui/styles/withStyles";
import { Grid, Slider, Typography, Button, Card, CardContent } from '@material-ui/core';

import BluetoothIcon from '@material-ui/icons/Bluetooth';

import { AuthContext } from "../context/auth";

import { LocoXtreme, MotorDirectionC } from "../libraries/LocoXtreme";

import Topbar from "./Topbar";
import GeneralMessage from "./drawers/GeneralMessage";
import LXSettingsModal from './modals/LXSettingsModal';

import locoXtremeRobot from "../images/LocoXtreme/lx_adv_robot.webp";

const AdvBackgroundShape = require("../images/LocoXtreme/products-bg.webp");

const LX_SITE_LINK = "https://codemyrobots.com/product/locoxtreme/";

const IMG_SIZE = 150;

// Material-UI CSS-type Style Specifications
const styles = (theme) => ({
    root: {            
        flexGrow: 1,
        backgroundColor: "white",
    },
    formControl: {
        width: "95%",
        justify: "center",
        margin: theme.spacing(0),
    },
    inputField: {
        width: "90%",
        marginLeft: theme.spacing(2),
    },
    inputHelper: {
        marginLeft: theme.spacing(4),
    },
    grid: {       
        width: '95%', 
        flexGrow: 1,
        margin: theme.spacing(4),
    },
    boxGraphs: {
        backgroundColor: theme.palette.primary["light"],
        //maxWidth: '90%',
    },
    instructBox: {
        backgroundColor: theme.palette.primary["light"],
    },
    speedBox: {
        backgroundColor: theme.palette.primary["light"],
        margin: '10px',
    },
    paper: {
        //flexGrow: 1,
        padding: theme.spacing(1),
        textAlign: "center",
        alignItems:"center",
        justifyContent:"center",
        color: theme.palette.primary,
        backgroundColor: theme.palette.primary["light"],
        maxWidth: '80%',
        borderRadius:'25px',
    },
    graphSpec: {
        alignItems:"center",
        justifyContent:"center",
        borderRadius:'25px',
        padding: 10,
        width: 500,
    },
    actionButton: {
        justify: "center",
        margin: theme.spacing(1),
        color: theme.palette.primary["contrastText"],
        backgroundColor: "green",
        borderRadius: '25px',
    },
    input: {
        justify: "center",
        margin: theme.spacing(2),
        color: theme.palette.primary["contrastText"],
        backgroundColor: theme.palette.primary["light"],
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        height: 150, // Set the height of the card
        maxWidth: 500, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        borderRadius: '10px',
    },
    cardLeft: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        height: 150, // Set the height of the card
        maxWidth: 500, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        borderRadius: '10px',
        transition: 'transform 0.3s, box-shadow 0.3s', // Add transition for smooth hover effect
        '&:hover': {
            transform: 'scale(1.05)', // Slightly scale up the card on hover
            boxShadow: theme.shadows[6], // Add a shadow effect on hover
        },
    },
    icon: {
        fontSize: 40,
        marginBottom: theme.spacing(1),
        //transition: 'transform 0.3s', // Add transition for smooth rotation
        //'&:hover': {
        //    transform: 'rotate(360deg)', // Rotate the icon on hover
        //},
        transition: 'color 0.2s', // Add transition for smooth effect
        '&:hover': {
            animation: '$moveBackAndForth 0.5s ease-in-out', // Apply animation on hover
        },
    },
    '@keyframes moveBackAndForth': {
        '0%': {
            transform: 'translateX(0)',
        },
        '25%': {
            transform: 'translateX(-5px)',
        },
        '50%': {
            transform: 'translateX(5px)',
        },
        '75%': {
            transform: 'translateX(-5px)',
        },
        '100%': {
            transform: 'translateX(0)',
        },
    },
    formControlSelect: {
        justify: "center",
        margin: theme.spacing(1),
    },
    gridSelect: {
        //marginTop: theme.spacing(4),
        background: `linear-gradient(45deg, ${theme.palette.secondary.lighter} 30%, ${theme.palette.secondary.lighter} 90%)`,
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        height: '100%', // Take up the full height of the parent
        display: 'flex',
        flexDirection: 'row', // Ensure the cards stay in the same row
        alignItems: 'flex-start', // items vertically
        justifyContent: 'center', // Align items to the start
    },
    cardUpper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(1),
        height: '50%', // Set the height of the card
        maxWidth: 400, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        marginBottom: theme.spacing(2), // Add some space between the cards
        borderRadius: '10px',
        transition: 'transform 0.3s, box-shadow 0.3s', // Add transition for smooth hover effect
        '&:hover': {
            transform: 'scale(1.05)', // Slightly scale up the card on hover
            boxShadow: theme.shadows[6], // Add a shadow effect on hover
        },
    },
    cardLower: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3),
        height: '50%', // Set the height of the card
        maxWidth: 500, // Set a maximum width for the cards
        margin: 'auto', // Center the cards horizontally
        borderRadius: '10px',
        transition: 'transform 0.3s, box-shadow 0.3s', // Add transition for smooth hover effect
        '&:hover': {
            transform: 'scale(1.05)', // Slightly scale up the card on hover
            boxShadow: theme.shadows[6], // Add a shadow effect on hover
        },
    },
    select: {
        width: 175,
        //'&:hover': {
        //    backgroundColor: theme.palette.tertiary.lighter,
        //},
        transition: 'border-width 0.2s', // Add transition for smooth effects
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.tertiary.lighter,
            borderWidth: '4px', // Change border thickness on hover
        }
    },
    menuItem: {
        '&:hover': {
            backgroundColor: theme.palette.tertiary.lighter,
        },
    },
    valueLabelRight: {
        left: '100% !important',
        right: 'auto !important',
        top: '50% !important',
        transform: 'translateY(-50%) rotate(0deg) !important',
        background: '#1976d2',
        color: '#fff',
        borderRadius: 4,
        minWidth: 32,
        textAlign: 'center',
        '& *': {
            transform: 'none !important',
            background: 'transparent !important', // Remove unwanted backgrounds
            color: '#fff !important', // Ensure text is white
        },
    },
    valueLabelLeft: {
        left: 'auto !important',
        right: '100% !important',
        top: '50% !important',
        transform: 'translateY(-50%) rotate(0deg) !important',
        background: '#1976d2',
        color: '#fff',
        borderRadius: 4,
        minWidth: 32,
        textAlign: 'center',
        '& *': {
            transform: 'none !important',
            background: 'transparent !important', // Remove unwanted backgrounds
            color: '#fff !important', // Ensure text is white
        },
    },
    about_root: {
        display: 'flex',
        maxHeight: `calc(100vh - ${window.navBarOffset})`, 
        minHeight: `calc(100vh - ${window.navBarOffset})`, 
        overflow: 'auto',
        //overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: `#040833 url(${AdvBackgroundShape}) no-repeat`,
        backgroundSize: "auto 100%",//"cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    },
    text: {
        width: '40%',
        textAlign: 'center',
        color: '#3f51b5',
        fontWeight: 'bold',
        marginLeft: theme.spacing(10),
    },  
    gradientButton: {
        textTransform: 'none',
        background: 'linear-gradient(135deg, #275ff6 35%, #bae9ff 100%)',
        color: 'white',
        size: 'large', // Make the button larger
        fontSize: '1.5rem',
        padding: theme.spacing(1), // Add padding to the button
        borderRadius: theme.shape.borderRadius * 2, // Make the edges more rounded
        '&:hover': {
            background: 'linear-gradient(-45deg, #275ff6 35%, #bae9ff 100%)',
        },
    },
    marginRight: {
        marginRight: theme.spacing(1),
    },
    marginBottom: {
        marginBottom: theme.spacing(3),
    },
    image: {
        width: '40%',
        height: 'auto',
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
});

const keyImages = {
  left: '/images/LXRC/TG_Left.svg', // TG keys
  right: '/images/LXRC/YH_Right.svg', // YH keys
};

class LXRC extends React.Component {
    
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      connected: false,
      leftSpeed: 0,
      rightSpeed: 0,
      bothSpeeds: 0,
      leftKey: null,
      rightKey: null,
    };

    this.LXObj = null;

    this.scanMessageRef = React.createRef();
    this.selectModalRef = React.createRef();
    this.connMessageRef = React.createRef();
  }

  componentDidMount() {
    this.LXObj = new LocoXtreme();
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp); // Listen for keyup
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);

    if (this.state.connected) {
        try {
            this.LXObj.reset_ble().then(() => {
                this.LXObj.reset_ble().then(() => {
                    this.LXObj.disconnect();
                });
            });
        } catch {}
    }
  }

  handleKeyDown = (e) => {
    const { connected, leftSpeed, rightSpeed, leftKey, rightKey } = this.state;
    if (!connected || e.repeat) return;

    let changed = false;
    let directionL = leftKey === 'g' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
    let directionR = rightKey === 'h' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
    let leftPressed = false;
    let rightPressed = false;
    switch (e.key.toLowerCase()) {
      case 't':
      case 'g':
        leftPressed = true;
        if (!leftKey) {
            changed = true;
            directionL = e.key.toLowerCase() === 'g' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
            // Only trigger if neither t nor g is already pressed
            this.setState({ leftKey: e.key.toLowerCase() });
        }
        break;
      case 'y':
      case 'h':
        rightPressed = true;
        if (!rightKey) {
            changed = true;
            directionR = e.key.toLowerCase() === 'h' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
            // Only trigger if neither t nor g is already pressed
            this.setState({ rightKey: e.key.toLowerCase() });
        }
        break;
      default:
        break;
    }
    
    if (changed) {
        // Handle the case where a key is pressed previously but not what triggered this
        if (!leftPressed) {
            if (leftKey !== null) {
                leftPressed = true;
            }
        }
        if (!rightPressed) {
            if (rightKey !== null) {
                rightPressed = true;
            }
        }
        // speed should only be set if the key is pressed
        const speedL = leftPressed ? Math.abs(leftSpeed) / 100 : 0;
        const speedR = rightPressed ? Math.abs(rightSpeed) / 100 : 0;
        this.LXObj.move(directionL, directionR, speedL, speedR);
    }
    this.setState({});
  };

  handleKeyUp = (e) => {
    const { leftKey, rightKey, leftSpeed, rightSpeed } = this.state;

    let leftPressed = leftKey !== null;
    let rightPressed = rightKey !== null;
    let directionL = leftKey === 'g' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
    let directionR = rightKey === 'h' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
    let changed = false;
    if ((e.key.toLowerCase() === 't' || e.key.toLowerCase() === 'g') && leftKey === e.key.toLowerCase()) {
      changed = true;
      leftPressed = false;
      this.setState({ 
        leftKey: null,
      });
    }
    if ((e.key.toLowerCase() === 'y' || e.key.toLowerCase() === 'h') && rightKey === e.key.toLowerCase()) {
      changed = true;
      rightPressed = false;
      this.setState({
        rightKey: null,
      });
    }

    if (changed) {
        // on either release, speed needs to be set to 0
        // the speeds should be set only if the corresponding key press is down
        const speedL = leftPressed ? Math.abs(leftSpeed) / 100 : 0;
        const speedR = rightPressed ? Math.abs(rightSpeed) / 100 : 0;
        this.LXObj.move(directionL, directionR, speedL, speedR);
    }
  };
  
  handleConnectToggle = async () => {

    let newConnectedState = !this.state.connected

    // try to actually connect if not connected
    if (newConnectedState) {
        this.connMessageRef.current.handleOpenStay('blue', 'Connecting...');

        const usb_conn_resp = await this.LXObj.connect();
        if (usb_conn_resp !== "done") {
            this.connMessageRef.current.handleClose();
            return;
        }

        setTimeout(this.postConnectLX, 250);
    } else {
        try {
            this.connMessageRef.current.handleOpenStay('blue', 'Disconnecting...');
            await this.LXObj.deactivate_motors();
            await this.LXObj.reset_ble();
            await this.LXObj.disconnect();
        } catch (err) {}
        finally {
            this.connMessageRef.current.handleClose();
        }
        this.setState((prevState) => ({
            connected: newConnectedState,
            leftSpeed: prevState.connected ? 0 : prevState.leftSpeed,
            rightSpeed: prevState.connected ? 0 : prevState.rightSpeed,
            bothSpeeds: prevState.connected ? 0 : prevState.bothSpeeds,
        }));
    }
  };

  handleLeftChange = (e, value) => {
    const { leftKey, rightKey, rightSpeed } = this.state;
    const avg = Math.round((value + rightSpeed) / 2);
    this.setState({ leftSpeed: value, bothSpeeds: avg });
    if (leftKey || rightKey) {
        const directionL = leftKey === 'g' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
        const directionR = rightKey === 'h' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
        const speedL = leftKey ? Math.abs(value) / 100 : 0;
        const speedR = rightKey ? Math.abs(rightSpeed) / 100 : 0;
        this.LXObj.move(directionL, directionR, speedL, speedR);
    }
  };

  handleRightChange = (e, value) => {
    // if leftKey or rightKey is pressed, update the move()
    const { leftKey, rightKey, leftSpeed } = this.state;
    const avg = Math.round((value + leftSpeed) / 2);
    this.setState({ rightSpeed: value, bothSpeeds: avg });
    if (leftKey || rightKey) {
        const directionL = leftKey === 'g' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
        const directionR = rightKey === 'h' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
        const speedL = leftKey ? Math.abs(leftSpeed) / 100 : 0;
        const speedR = rightKey ? Math.abs(value) / 100 : 0;
        this.LXObj.move(directionL, directionR, speedL, speedR);
    }
  };

  handleBothChange = (e, value) => {
    const { leftKey, rightKey } = this.state;
    this.setState({ bothSpeeds: value, leftSpeed: value, rightSpeed: value });

    // If either key is pressed, determine directions and call move
    if (leftKey || rightKey) {
        const directionL = leftKey === 'g' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
        const directionR = rightKey === 'h' ? MotorDirectionC.Backward : MotorDirectionC.Forward;
        // Use value/100 for the speed if the key is pressed, otherwise 0
        const speedL = leftKey ? Math.abs(value) / 100 : 0;
        const speedR = rightKey ? Math.abs(value) / 100 : 0;
        this.LXObj.move(directionL, directionR, speedL, speedR);
    }
  };

  openLXSelection = () => {
    this.selectModalRef.current.handleOpen("PICK", this.LXObj.robots);
  }

  postConnectLX = () => {

    this.connMessageRef.current.handleClose();
    if (!window.serialport) {
        return
    }

    const SCAN_TIME = 4000;
    const SCAN_MSG_TIME = 5000;
    this.scanMessageRef.current.handleOpen('green', 'Scanning...', SCAN_MSG_TIME)
    this.LXObj.scan_start(SCAN_TIME).catch(err => console.error('Scan start failed:', err));
  }

  LXSelection = async (r_event) => {
                
    let targetIndex = -1;
    for (let i = 0; i < this.LXObj.robots.length; i++) {
        if (this.LXObj.robots[i]['name'] === r_event) {
            targetIndex = i
            break
        }
    }
        
    if (targetIndex !== -1) {
        this.connMessageRef.current.handleOpenStay('blue', 'Connecting...');
        try {
            await this.LXObj.connect_ble(targetIndex)
            await this.LXObj.activate_motors();

            this.connMessageRef.current.handleClose();
            this.setState((prevState) => ({
                connected: !prevState.connected,
                leftSpeed: prevState.connected ? 0 : prevState.leftSpeed,
                rightSpeed: prevState.connected ? 0 : prevState.rightSpeed,
            }));
        } catch (err) {
            this.connMessageRef.current.handleOpen('red', 'Could Not Connect To Robot, Please Try Again', 1000);
        }

    } else {
        await this.LXObj.reset_ble();
        await this.LXObj.disconnect();
    }
  }

  handleStop = async () => {
    try {
      this.setState({ leftSpeed: 0, rightSpeed: 0 }, () => {
        const left = this.getMotorDirAndSpeed(0);
        const right = this.getMotorDirAndSpeed(0);
        //lmd, rmd, lms, rms
        this.LXObj.move(left.dir, right.dir, left.speed, right.speed);
      });
    } catch {}
  }



  render() {

    const { classes } = this.props;
    const { connected, leftSpeed, rightSpeed, bothSpeeds } = this.state;
    
    // Check if userAccess array includes "LocoXtreme"
    const hasLocoXtremeAccess = this.context.AuthInstance.userAccess.includes("LocoXtreme");

    // For TopBar Route Highlight
    const currentPath = this.props.location.pathname;

    return (
        <div className={classes.root}    
            style={{ height: '100vh', maxHeight: '100vh', backgroundColor: 'white', overflow: 'hidden'}}>
            <CssBaseline />
            <Topbar currentPath={currentPath} />
            {hasLocoXtremeAccess ? (
                <Grid container justifyContent="center" className={classes.gridSelect}>
                    <Grid item xs={12} md={12}>
                        <Card className={classes.cardUpper}>
                            <Grid container justifyContent="center" alignItems="center">
                                <Grid item>
                                    <BluetoothIcon className={classes.icon} color="primary" />
                                </Grid>
                                <Grid item>
                                    <CardContent>
                                        <Typography variant="h5" component="h2">
                                            LocoXtreme Connection
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                            Connect to your LocoXtreme robot.
                                        </Typography>
                                    </CardContent>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color={connected ? 'secondary' : 'primary'}
                                        onClick={this.handleConnectToggle}
                                    >
                                        {connected ? 'Disconnect' : 'Connect'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                        <Card className={classes.cardLower}>
                            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                                {/* Left keys image */}
                                <Grid item>
                                    <img
                                        src={keyImages.left}
                                        alt="WS keys"
                                        title="Left"
                                        style={{ height: IMG_SIZE }}
                                    />
                                </Grid>
                                {/* Left motor title and slider */}
                                <Grid item>
                                    <Grid container direction="column" alignItems="center">
                                        <Typography style={{ marginBottom: 11 }}>
                                            Left Motor
                                        </Typography>
                                        <Slider
                                            orientation="vertical"
                                            value={leftSpeed}
                                            onChange={this.handleLeftChange}
                                            min={0}
                                            max={100}
                                            valueLabelDisplay="on"
                                            style={{ height: 200 }}
                                            disabled={!connected}
                                            classes={{ valueLabel: classes.valueLabelLeft }}
                                        />
                                    </Grid>
                                </Grid>
                                {/* Middle title and slider */}
                                <Grid item>
                                    <Grid container direction="column" alignItems="center">
                                        <Typography style={{ marginBottom: 11 }}>
                                            Both Motors
                                        </Typography>
                                        <Slider
                                            orientation="vertical"
                                            value={bothSpeeds}
                                            onChange={this.handleBothChange}
                                            min={0}
                                            max={100}
                                            valueLabelDisplay="off"
                                            style={{ height: 200 }}
                                            disabled={!connected}
                                        />
                                    </Grid>
                                </Grid>
                                {/* Right motor title and slider */}
                                <Grid item>
                                    <Grid container direction="column" alignItems="center">
                                        <Typography style={{ marginBottom: 11 }}>
                                            Right Motor
                                        </Typography>
                                        <Slider
                                            orientation="vertical"
                                            value={rightSpeed}
                                            onChange={this.handleRightChange}
                                            min={0}
                                            max={100}
                                            valueLabelDisplay="on"
                                            style={{ height: 200 }}
                                            disabled={!connected}
                                            classes={{ valueLabel: classes.valueLabelRight }}
                                        />
                                    </Grid>
                                </Grid>
                                {/* Right keys image */}
                                <Grid item>
                                <img
                                    src={keyImages.right}
                                    alt="IK keys"
                                    title="RIGHT"
                                    style={{ height: IMG_SIZE}}
                                />
                                </Grid>
                            </Grid>
                            </Card>
                    </Grid>
                </Grid>
            ) : (
                <div className={classes.about_root}>
                    <div className={classes.text}>
                        <Typography 
                            className={`${classes.marginRight} ${classes.marginBottom}`} 
                            variant="h4"
                            style = {{ color: 'white' }}
                        >
                            Explore LocoXtreme And The World Of Ground Robotics
                        </Typography>
                        <Button
                            className={classes.gradientButton}
                            href={LX_SITE_LINK}
                            target="_blank"
                            rel="noopener"
                        >
                            CodeMyRobots
                        </Button>
                    </div>
                    <img 
                        src={locoXtremeRobot} 
                        alt="LocoXtreme Robot" 
                        className={classes.image}
                    />
                </div>
            )}
            <GeneralMessage
                ref = {this.scanMessageRef}
                onClose = {this.openLXSelection}
            />
            <GeneralMessage
                ref = {this.connMessageRef}
                onClose = {() => void 0}
            />
            <LXSettingsModal
                ref = {this.selectModalRef}
                onClose={this.LXSelection}
            />
        </div>
    );
  }
};

export default withRouter(withStyles(styles)(LXRC));